import{parseString}from'xml2js';import{GmlV1ToSalt}from'./transpiler';GmlV1ToSalt.xmlParser=parseString;export*from'./transpiler';